import useSWRMutation from "swr/mutation";

import { MUTATION_OPTIONS, postJSONWithCSRF } from "@/utils/swr";

import { CYO_ERRORS } from "./constants";

interface CYOResponseData {
  id: number;
  email: string;
  first_name: string;
  last_name: string;
  created_at: string;
}

const API_URL = `${import.meta.env.VITE_API_HOST}/api/enquiries_new`;

const postCYO = postJSONWithCSRF<CYOResponseData>(CYO_ERRORS.GENERIC_ERROR, {
  createBody: ({ arg }) => JSON.stringify(arg),
  requestOptions: {
    // Use a getter function to read CSRF token at request time
    get headers() {
      const metaToken = document.querySelector('meta[name="csrf-token"]');
      const csrfToken = metaToken
        ? metaToken.getAttribute("content") || ""
        : "";
      return {
        "X-CSRF-Token": csrfToken,
      };
    },
  },
});

export const useCYOQuery = (params?: {
  onSuccess?: () => void;
  onError?: () => void;
}) => {
  const { onSuccess, onError } = params ?? {};
  const { trigger, error, isMutating } = useSWRMutation(API_URL, postCYO, {
    ...MUTATION_OPTIONS,
    onSuccess,
    onError,
  });

  return {
    CYOError: error,
    isSubmittingCYO: isMutating,
    submitCYO: trigger,
  };
};
